import { query } from '@kk/utils';
import globalData from '@kk-activity-factory/global-data/global';
import { globalInstance } from '@kk-activity-factory/utils';

import { buildStore } from './src/store/index';

import types from './src/store/types';

export async function initKKActivityFactory(
    moduleStore,
    components,
    componentMap,
    nonConfiguarbleUtil,
    options
) {
    // 根据平台动态导入对应的入口文件
    const { init } = globalData.isPc ? await import('./src/pc') : await import('./src/main');

    globalInstance.setComponentsObject(components);
    globalInstance.setComponentMap(componentMap);
    globalInstance.setMutationsKeys(types);
    globalInstance.setNonConfiguarbleUtil(nonConfiguarbleUtil);
    const store = buildStore(moduleStore);
    globalInstance.setRootStore(store);
    if (options && options.beforeHandleFnList) {
        globalInstance.setBeforeHandleFnList(options.beforeHandleFnList);
    }
    if (options && options.afterHandleFnList) {
        globalInstance.setAfterHandleFnList(options.afterHandleFnList);
    }
    // 根据平台动态导入对应的 App 组件
    const vue = await init(store, () =>
        globalData.isPc
            ? import(
                  /*
                  webpackChunkName: "app.component.pc" */ /* webpackPreload: true */ './src/pc.vue'
              )
            : import(
                  /* webpackChunkName: "app.component" */ /* webpackPreload: true */ './src/App.vue'
              )
    );
    globalInstance.setRootVue(vue);
    setTimeout(() => {
        try {
            // 增加一些热修复css
            const hotfix = query.get('hotfix') === '1';
            if (globalData.isApple && hotfix && globalData.isFindTabLikeContainer) {
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = './css/hot-fix-1.css';
                document.head.appendChild(link);
            }
        } catch (error) {
            console.error(error);
        }
    }, 500);
    return {
        store,
        vue,
    };
}
